import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { BrowserQRCodeReader } from "@zxing/library";
import axios from "axios";
import "./scan.css";

const ScanQR = () => {
  const [qrCode, setQrCode] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [countdown, setCountdown] = useState(5);
  const [isScanning, setIsScanning] = useState(false);
  const [accessGranted, setAccessGranted] = useState(false);
  const [accessInput, setAccessInput] = useState("");
  const [accessError, setAccessError] = useState("");
  const [namaLengkap, setNamaLengkap] = useState("");
  const [waktuCheckin, setWaktuCheckin] = useState("");

  const videoRef = useRef(null);
  const timerRef = useRef(null);
  const ACCESS_KEY = "rlascan165";

  // --- HANDLE AKSES ---
  const handleAccessSubmit = () => {
    if (accessInput === ACCESS_KEY) {
      setAccessGranted(true);
      setIsScanning(true);
      setAccessError("");
    } else {
      setAccessError("Akses anda ditolak");
    }
  };

  // --- SETUP SCANNER ---
  useEffect(() => {
  if (!isScanning) return;

  const codeReader = new BrowserQRCodeReader();

  const startScanner = async () => {
    try {
      const videoInputDevices = await codeReader.listVideoInputDevices();

      // Pilih kamera belakang jika ada
      const backCamera = videoInputDevices.find((d) =>
        d.label.toLowerCase().includes("back")
      );

      const selectedDeviceId = backCamera
        ? backCamera.deviceId
        : videoInputDevices[0]?.deviceId;

      await codeReader.decodeFromVideoDevice(selectedDeviceId, videoRef.current, (result) => {
        if (result) {
          const qrData = result.getText();
          setQrCode(qrData);
          handleCheckIn(qrData);
          setIsScanning(false);
        }
      });
    } catch (err) {
      console.error("Gagal mengakses kamera:", err);
      alert("Tidak dapat mengakses kamera. Pastikan izin kamera diaktifkan.");
    }
  };

  startScanner();
  return () => codeReader.reset();
}, [isScanning]);


  // --- COUNTDOWN MODAL ---
  useEffect(() => {
    if (modalOpen && countdown > 0) {
      timerRef.current = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    } else if (countdown === 0) {
      toggleModal();
    }
    return () => clearTimeout(timerRef.current);
  }, [modalOpen, countdown]);

  // --- API CALL ---
  const handleCheckIn = (qrData) => {
    axios
      .post("https://tiket.rlagency.id/api/checkin_peserta.php", { qr_code: qrData })
      .then((res) => {
        const data = res.data;
        if (data.success) {
          setModalType("success");
          setModalMessage(data.message || "Check-in Berhasil!");
          setNamaLengkap(data.namaLengkap || "-");
          setWaktuCheckin(data.waktu_checkin || "-");
        } else {
          setModalType("failure");
          setModalMessage(data.message || "Check-in Gagal!");
          setNamaLengkap(data.namaLengkap || "-");
          setWaktuCheckin(data.waktu_checkin || "-");
        }
        setModalOpen(true);
        setCountdown(5);
      })
      .catch((err) => {
        console.error("Error:", err);
        setModalType("failure");
        setModalMessage("Terjadi kesalahan koneksi ke server");
        setModalOpen(true);
        setCountdown(5);
      });
  };

  // --- MODAL TOGGLE ---
  const toggleModal = () => {
    setModalOpen(false);
    setCountdown(5);
    setQrCode("");
    setNamaLengkap("");
    setWaktuCheckin("");
    setTimeout(() => setIsScanning(true), 800);
  };

  return (
    <div className="scan-page">
      {/* --- MODAL AKSES KEY --- */}
      {!accessGranted && (
        <Modal isOpen={!accessGranted} centered backdrop="static">
          <ModalHeader>Masukkan Akses Key</ModalHeader>
          <ModalBody>
            <input
              type="password"
              className="form-control mb-2"
              placeholder="Masukkan akses key..."
              value={accessInput}
              onChange={(e) => setAccessInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleAccessSubmit()}
            />
            {accessError && <p className="text-danger text-sm mb-0">{accessError}</p>}
          </ModalBody>
          <ModalFooter>
            <Button color="dark" onClick={handleAccessSubmit}>
              Masuk
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* --- HALAMAN SCAN --- */}
      {accessGranted && (
        <div className="scan-container">
          <h2 className="scan-title">QR Check-In</h2>
          <p className="scan-subtitle">Arahkan kamera ke QR Code peserta untuk melakukan check-in.</p>

          <div className="scan-video">
            <video ref={videoRef} className="video-feed" />
          </div>

          {/* --- MODAL HASIL --- */}
          <Modal isOpen={modalOpen} toggle={toggleModal} centered size="sm">
            <ModalHeader
              className={
                modalType === "success"
                  ? "modal-header-success"
                  : "modal-header-failure"
              }
            >
              {modalType === "success" ? "✅ Sukses" : "❌ Gagal"}
            </ModalHeader>
            <ModalBody className="text-center">
              <p className="modal-message">{modalMessage}</p>

              {namaLengkap && (
                <div className="modal-detail">
                  <p><strong>Nama:</strong><br />{namaLengkap}</p>
                  <p><strong>Waktu Check-in:</strong><br />{waktuCheckin}</p>
                </div>
              )}

              {qrCode && <p className="modal-qrcode">QR: {qrCode}</p>}
            </ModalBody>
            <ModalFooter>
              <Button
                color={modalType === "success" ? "success" : "danger"}
                onClick={toggleModal}
              >
                Tutup ({countdown})
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default ScanQR;
